/* tslint:disable */

/* eslint-disable */

export interface AbsenceInfoTO {
	absence: string;
	altRepresentative: string;
	comment: string;
	from: number;
	representative: string;
	to: number;
}

export interface AppEventParamTO {
	key: string;
	value: string;
}

export interface AppEventTO {
	eventname: string;
	hook: string;
	id: number;
	params: AppEventParamTO[];
	prio: number;
}

export interface AttachmentTO extends Serializable {
	acc?: number;
	data: string;
	dstField: string;
	filename?: string;
	lat?: number;
	lazy?: boolean;
	lon?: number;
	mimeType?: string;
	moveToPos?: number;
	persist?: boolean;
	pos: number;
	preview?: string;
	resolvedLink?: boolean;
	version?: number;
}

export interface AuftTO {
	auftkey: string;
	aufttext: string;
	gueltigBis: number;
	gueltigVon: number;
	kostkey: string;
	sollSt: number;
	status: string;
}

export interface AzeBookingErrorTO {
	bookingError: { [index: string]: string };
	bookingNr: number;
	koWertError: { [index: string]: string };
}

export interface AzeBookingTO {
	azeBookingErrorTo: AzeBookingErrorTO;
	bewEinh: string;
	bookingDate: number;
	bookingNr: number;
	bookingTime: number;
	bookingTimespan: number;
	bookingType: string;
	dev: string;
	edit: boolean;
	einstuf: number;
	empfEinh: string;
	hourCategory: string;
	koWertList: KoWertTO[];
	loeschKz: string;
	persNr: number;
	text: string;
	user: string;
}

export interface AzeDayInfoTO {
	anwesend: number;
	currDate: number;
	kontiert: number;
	nichtZuKont: number;
	offen: number;
	verrBis: number;
}

export interface AzeV2DataTO extends AzeBookingTO {
	fromDate: number;
	fromTime: number;
	id: string;
}

export interface BookingTO {
	bewEinh: string;
	bookingDate: number;
	bookingNr: number;
	bookingTime: number;
	bookingTimespan: number;
	bookingType: string;
	cf: AttachmentTO[];
	dev: string;
	einstuf: number;
	einstufArt: string;
	empfArt: string;
	empfEinh: string;
	gruppeKz: string;
	hourCategory: string;
	loeschKz: string;
	persNr: number;
	sisName: string;
	stKey: string;
	stTagKey: string;
	stornos?: StornoTO[];
	text: string;
	user: string;
}

export interface BuchungTO {
	benutzer: string;
	bewEinh: string;
	buart: string;
	buchdat: number;
	buchzeit: number;
	buchzsp: number;
	butext: string;
	datum: number;
	dev: string;
	einstuf: number;
	einstufArt: string;
	empfArt: string;
	empfEinh: string;
	gruppeKz: string;
	id: number;
	kartnr: number;
	kbuchnr: number;
	leistArt: string;
	leistEinh: number;
	loeschKz: boolean;
	stTagkey: string;
	stkey: string;
	stuart: string;
	sysdat: number;
	syszeit: number;
	verrKz: string;
}

export interface CFAttrTO {
	cfdef: number;
	id: number;
	key?: string;
	type?: string;
	value: string;
}

export interface CFGroupTO extends Serializable {
	heading: string;
	id: number;
	mergeAmountButtons: boolean;
}

export interface CFValiTO {
	cacheTTL: string;
	dqParams: DqParamTO[];
	id: number;
}

export interface ChatMemberTO {
	chatId: number;
	chatUserId: number;
	deleted?: boolean;
}

export interface ChatMessageTO {
	chatId: number;
	chatUserId: number;
	id: number;
	msg: string;
	ts: number;
}

export interface ChatTO {
	id: number;
	maxMembers?: number;
	members: ChatMemberTO[];
	name?: string;
	newestTS: number;
	startTS: number;
}

export interface ChatUserTO {
	active: boolean;
	anonym: boolean;
	generated: boolean;
	id: number;
	master: boolean;
	myself: boolean;
	name?: string;
}

export interface ClientColumnTO {
	cell: string;
	columnProps: { [index: string]: any };
	editable: boolean;
	filterMethod: ColumnFilterMethod;
	filterable: boolean;
	label: string;
	name: string;
	renderable: boolean;
	sortable: boolean;
}

export interface ColorPairTO {
	bgColor?: string;
	textColor?: string;
}

export interface CompoundPropertyTO {
	attribute: string;
	compositeId: string;
	object: string;
	subkrit: string;
	type: PropType;
	value: string;
}

export interface CreateChatMessageTO {
	chatId: number;
	msg: string;
}

export interface CreateChatTO {
	members: number[];
}

export interface CustomFieldTO {
	cfAttrs: CFAttrTO[];
	cfGroupId?: number | null;
	cfValiIds: number[];
	colSpan?: number | null;
	defaultValue?: string | null;
	dqKey: string;
	dqParams: DqParamTO[];
	dstField: string;
	forceDq: boolean;
	funcOnInsert?: string | null;
	hpos?: number;
	id: number;
	input: string;
	insertable: boolean;
	label: string;
	length: number;
	maxAmount: number;
	minAmount: number;
	mtab: string | null;
	mustMatchDq: boolean;
	nullValue?: string | null;
	pinned: boolean;
	primaryKey: boolean;
	required: boolean;
	rowSpan?: number | null;
	searchable: boolean;
	sortable: boolean;
	startIndex: number;
	type: SisType;
	updatable: boolean;
	visible: boolean;
	vpos?: number;
	zpos?: number;
}

export interface DTSpannable {
	bisdat: number;
	biszeit: number;
	vondat: number;
	vonzeit: number;
}

export interface DataFilterCFDefMapTO {
	cfDefs: CustomFieldTO[];
	cfDefsCompact: CustomFieldTO[];
}

export interface DayInfoSollTO {
	compositeId: string;
	date: number;
	persNr: number;
	sisName: string;
	soll: number;
}

export interface DayInfoTO {
	className: string;
	compositeId: string;
	date: number;
	ist: number;
	persNr: number;
	sisName: string;
	soll: number;
}

export interface DqButtonTO {
	dqKey: string;
	icon?: string;
	id: number;
	label?: string;
	location: string;
	locationDiscriminator?: string;
	position: number;
	tooltip?: string;
}

export interface DqParamTO {
	defaultValue: string | null;
	dstName: string;
	id?: number;
	length?: number;
	srcName: string;
	startIndex: number;
	type: string;
}

export interface DqRequestTO {
	filter?: string;
	id: string;
	isAze?: boolean;
	params?: { [index: string]: any };
}

export interface DqResponseTO {
	cacheTTL: string;
	count: number;
	elements: { [index: string]: string }[];
	id: string;
	label: string;
	searchable: boolean;
}

export interface EFileCatTO {
	cfDef: CustomFieldTO | null;
	color: ColorPairTO;
	entity: EFileEntity;
	id: number;
	name: string;
	nr: number | null;
	perm: PermissionTO;
}

export interface EFileCreateRequestTO {
	efile: EFileTO;
	entityID: EntityIdTO;
}

export interface EFileTO {
	category: number;
	data?: string;
	filename: string;
	id: number;
	mimeType: string;
	nr: number;
}

export interface EmployeeAbsenceTO {
	absenceType: string;
	dateFrom: number;
	dateTo: number;
	persNr: number;
}

export interface EntityFieldTO {
	dq2Label?: string;
	dq2Value?: string;
	dq2ValueParams: string[];
	entity: string;
	entityField: string;
	filterable: boolean;
	id?: number;
	label?: string;
	nr: number;
	readable: boolean;
	sortable: boolean;
	type?: string;
	visible: boolean;
}

export interface EntityIdTO {
	auftkey?: string | null;
	entity: EFileEntity;
	kostkey?: string | null;
	persNr?: number | null;
	taskId?: number | null;
}

export interface EntryDescInitTO {
	entryDescId: number;
	kost?: string;
	onlyOne?: boolean;
}

export interface EntryDescTO extends RulesetTO {
	bookingType: string;
	bookingTypeText: string;
	groupLabel?: string;
	hourCategory: string;
	hourCategoryText: string;
	icon?: string;
	id: number;
	label?: string;
	perm?: PermissionTO | null;
	rulesetSelfAdmin?: RulesetTO | null;
	sortKey: number;
	terminalColor: ColorPairTO;
	typeCategoryColor: ColorPairTO;
	typeColor: ColorPairTO;
	typeGroupId?: number | null;
}

export interface EventContainerTO {
	eventParams: EventParamTO[];
	events: EventTO[];
}

export interface EventParamTO {
	key: string;
	parentId: number;
	value: string;
}

export interface EventTO {
	eventname: string;
	hook: string;
	id: number;
	prio: number;
}

export interface EvoAppsUserInfoTO {
	calculation: PersonCalculationInfoTO;
	className: string;
	costCenter: PersonCostCenterInfoTO;
	evoAppsUser: EvoAppsUserWrapperTO;
	ewsRepList: EwsRepTO[];
	mailVertretungRendered: boolean;
	passwordPanelRendered: boolean;
	personalInfo: PersonalInfoTO;
	useTmsKw: boolean;
	visiblePersNrInfo: string;
	vorgztUserRendered: boolean;
}

export interface EvoAppsUserTO {
	className: string;
	email: string;
	longUsername: string;
	persNr: number;
	text: string;
	userGroup: MenugrpTO;
	username: string;
}

export interface EvoAppsUserWrapperTO {
	alternativeMandants: MandantTO[];
	alternativeUser: boolean;
	alternativeUsers: EvoAppsUserTO[];
	className: string;
	defaultEvoAppsUser: EvoAppsUserTO;
	defaultMandant: MandantTO;
	email: string;
	longUsername: string;
	mandant: MandantTO;
	nativeLoggedIn: boolean;
	persNr: number;
	text: string;
	userGroup: MenugrpTO;
	username: string;
	vorgesetzterUser: VorgztUserTO;
}

export interface EvoMenuParamTO {
	evomenu: number;
	id: number;
	key: string;
	type: string;
	value: string;
}

export interface EvoMenuTO {
	appinst: string | null;
	icon: string | null;
	id: number;
	label: string | null;
	menu_gid: string;
	modul: string;
	modulTyp: ModuleType;
	nr: number;
	pageUrl: string;
	params: EvoMenuParamTO[];
	parent: number | null;
}

export interface EwsRepTO {
	displayName: string;
	repAddress: string;
	useFwdRule: boolean;
}

export interface FavoriteTO {
	className: string;
	ilvKuerz: string;
	koWertLabels: string[];
	koWertList: string[];
	koWertVisbaleColumns: boolean[];
	name: string;
	text: string;
}

export interface FreigabeKostRequestTO {
	date: number;
	kostkey: string;
	vorgUser: string;
}

export interface FreigabeKostVorgFixedValueRequestTO {
	date: number;
	kostkeys: string[];
}

export interface FreigabePersRequestTO {
	date: number;
	persNr: number;
}

export interface FreigabeTO {
	blocking: boolean;
	bookingNr: number;
	buart: string;
	color: ColorPairTO;
	date: number;
	kostkey: string;
	label: string;
	persNr: number;
	rank: number;
	time: number;
	type: FreigabeType;
	vorgText: string;
}

export interface GetAttachmentTO {
	bookingType: string;
	dstField: string;
	fetchMode: AttachmentFetchMode;
	hourCategory: string;
	id: number;
	persNr: number;
	pos: number;
	sisName: SisName;
}

export interface HolidayTO {
	compositeId: string;
	feierDatum: number;
	feierKey: string;
	sisName: string;
	text: string;
}

export interface ISSMaxWorkTimeTO {
	maxDaySum: number;
	maxWeekSum: number;
}

export interface IstZeitTO {
	compositeId: string;
	date: number;
	ist: number;
	persNr: number;
}

export interface KoKeyConfTO {
	dayInfos: AzeDayInfoTO[];
	koKeys: { [index: string]: string }[];
	persNr: number;
	tolerance: number;
}

export interface KoWertTO {
	dqKey: string;
	label: string;
	name: string;
	nr: number;
	required: string;
	size: number;
	type: string;
	value: string;
	visible: boolean;
}

export interface KontStammTO {
	bewEinh: string;
	bisdat: number;
	empfEinh: string;
	leistungsart: string;
	persNr: number;
	vondat: number;
}

export interface KostTO {
	active?: string;
	addCfld1?: string;
	addCfld2?: string;
	addCfld3?: string;
	addCfld4?: string;
	addCfld5?: string;
	addDfld1?: number;
	addDfld2?: number;
	addDfld3?: number;
	addDfld4?: number;
	addDfld5?: number;
	addIfld1?: number;
	addIfld2?: number;
	addIfld3?: number;
	addIfld4?: number;
	addIfld5?: number;
	addKfld1?: string;
	addKfld2?: string;
	arge?: string;
	bauleiter?: string;
	bedanl?: string;
	bedlaend?: string;
	bgl1?: string;
	bgl2?: string;
	costId: string;
	costText?: string;
	datanl?: number;
	datlaend?: number;
	department?: string;
	establishment?: string;
	extKostKey?: string;
	kostMM?: { [index: string]: string };
	land?: string;
	location?: string;
	polier?: string;
	postCode?: string;
	region?: string;
	satz1?: number;
	satz2?: number;
	satz3?: number;
	satz4?: number;
	serviceType?: string;
	sollSt?: number;
	sortIndex?: number;
	street?: string;
	terminal?: string;
	username?: string;
	validFrom?: number;
	validTill?: number;
	zeitanl?: number;
	zeitlaend?: number;
}

export interface MaintenanceCollectionReqTO {
	orderBy?: OrderByTO[];
	page: number;
	search?: string;
	size: number;
	tableName: string;
	where?: RestrictionTO[];
}

export interface MaintenanceTableFlatTO extends Serializable {
	icon?: string;
	label?: string;
	name: string;
}

export interface MaintenanceTableTO extends Serializable {
	create: boolean;
	delete: boolean;
	fields: CustomFieldTO[];
	icon?: string;
	label?: string;
	name: string;
	read: boolean;
	relations: TableRelationTO[];
	update: boolean;
}

export interface MandantLockTO {
	bisdat: number;
	className: string;
	mandantLockDispalyText: string;
	vondat: number;
}

export interface MandantTO {
	className: string;
	id: string;
	mandantLock: MandantLockTO;
	mandantLockDispalyMessage: string;
	text: string;
}

export interface MenugrpTO {
	className: string;
	description: string;
	id: string;
	userLevel: string;
}

export interface ModelChangeBookingTO {
	bookingNr: number;
	datum: number;
	persNr: number;
	stTagkey: string;
	stkey: string;
}

export interface NotiDispatcherCFDefsTO {
	noti: CustomFieldTO[];
	receiver: CustomFieldTO[];
}

export interface NotiQueueTO {
	action?: string | null;
	actiontype?: string | null;
	bisdat: number;
	biszeit: number;
	bkey?: string | null;
	content?: string | null;
	deletable: string;
	hidden?: string | null;
	id?: number | null;
	lcts: Date;
	nr: number;
	prioritaet: number;
	read: string;
	receivers: string[];
	status: NotiStatus;
	title?: string | null;
	vondat: number;
	vonzeit: number;
}

export interface NotiTO {
	action?: string;
	actionType?: string;
	bisDat: number;
	bisZeit: number;
	bkey: string;
	content?: string;
	deletable: boolean;
	hidden?: string;
	id: number;
	nr: number;
	prio: number;
	read: boolean;
	title?: string;
	user: string;
	vonDat: number;
	vonZeit: number;
}

export interface OrderByTO {
	column: string;
	direction?: OrderDirection;
}

export interface PaginationResultTO {
	count: number;
	orderBy?: OrderByTO[];
	rows: { [index: string]: any }[];
}

export interface ParamdivTO {
	app: string;
	compositeId: string;
	crit: string;
	subCrit: string;
	value: string[];
}

export interface PermissionTO {
	abl?: boolean;
	abl_s?: boolean;
	crt?: boolean;
	crt_s?: boolean;
	del?: boolean;
	del_s?: boolean;
	gen?: boolean;
	gen_s?: boolean;
	rd?: boolean;
	rd_s?: boolean;
	storno?: boolean;
	storno_s?: boolean;
	upd?: boolean;
	upd_s?: boolean;
}

export interface PersInfTO {
	code: string;
	details: string[];
	fkey: string;
	from: number;
	nr: number;
	persInfoId: number;
	persNr: number;
	text1: string[];
	text10: string[];
	text11: string[];
	text12: string[];
	text13: string[];
	text14: string[];
	text15: string[];
	text16: string[];
	text17: string[];
	text18: string[];
	text19: string[];
	text2: string[];
	text3: string[];
	text4: string[];
	text5: string[];
	text6: string[];
	text7: string[];
	text8: string[];
	text9: string[];
	to: number;
}

export interface PersNrsDateRangeTO {
	from: number;
	persNrs: number[];
	to: number;
}

export interface PersStat2TO {
	benutzer: string;
	lbuchnr: number;
	persNr: number;
	status: string;
	statusBis: number;
	vdatum: number;
	verrBis: number;
	vzeit: number;
}

export interface PersonCalculationInfoTO {
	className: string;
	clearedToDate: string;
	errorMessages: VlFehlTO[];
	panelRendered: boolean;
}

export interface PersonCostCenterInfoTO {
	baseBewEinh: string;
	className: string;
	currentBewEinh: string;
	empfEinh: string;
	panelRendered: boolean;
}

export interface PersonMetaTO {
	disabled?: boolean;
	dotcolor?: string;
	hidden?: boolean;
	persNr: number;
	sortnr?: number;
	textcss?: string;
	tooltip?: string;
}

export interface PersonPhotoTO {
	persNr: number;
	photo: string;
	version: number;
}

export interface PersonTO {
	addCfld1?: string;
	addCfld2?: string;
	addCfld3?: string;
	addCfld4?: string;
	addCfld5?: string;
	addDfld1?: number;
	addDfld2?: number;
	addDfld3?: number;
	addDfld4?: number;
	addDfld5?: number;
	addFfld1?: number;
	addFfld2?: number;
	addFfld3?: number;
	addFfld4?: number;
	addFfld5?: number;
	addIfld1?: number;
	addIfld2?: number;
	addIfld3?: number;
	addIfld4?: number;
	addIfld5?: number;
	addKfld1?: string;
	addKfld2?: string;
	addKfld3?: string;
	addKfld4?: string;
	addKfld5?: string;
	angFrom?: number;
	angTill?: number;
	arbverh?: string;
	arplMasch?: string;
	artikelnr?: string;
	befrist1?: number;
	befrist2?: number;
	befristUrl?: number;
	bereich?: string;
	betriebsnr?: string;
	bezirk?: string;
	bezugsart?: string;
	bookingApproval: number;
	bookingApprovalTime: number;
	bookingEnd: number;
	bookingEndAze: number;
	boundaries: { [index: string]: WorkTimeModelTO };
	dayInfos: DayInfoTO[];
	email?: string;
	erlBeruf?: string;
	extPersnr?: string;
	extSubnr?: string;
	famstand?: string;
	firmein?: number;
	flsBisdat?: number;
	flsVondat?: number;
	gebOrt?: string;
	gebbezirk?: string;
	gebdat?: number;
	gebland?: string;
	gemeinde?: string;
	geschlecht?: string;
	heiratdat?: number;
	hidden: boolean;
	kartNr?: number;
	kleidgr?: string;
	land?: string;
	loeschKz?: string;
	lohngruppe?: string;
	maedname?: string;
	mandantAktiv: string;
	meistVor?: string;
	myself: boolean;
	nation?: string;
	ort?: string;
	persNr: number;
	plz?: string;
	probezeit?: number;
	produktiv?: string;
	religion?: string;
	revier?: string;
	rznr?: string;
	schuhgr?: string;
	sortIndex: number;
	stdlohn?: number;
	taetig?: string;
	telNr?: string;
	titel?: string;
	ueberam?: number;
	urlAnspr?: number;
	urlKon?: number;
	verrechnung?: string;
	versnr?: string;
	verwendgr?: string;
	vorg1?: number;
	vorg2?: number;
	vorg3?: number;
	vorname?: string;
	vwgrpab?: number;
	zuname?: string;
}

export interface PersonalInfoTO {
	className: string;
	infos: string[];
	panelRendered: boolean;
}

export interface PersstChangeRequestTO {
	auslandKz?: string;
	azebukz?: string;
	bewEinh?: string;
	bisdat: number;
	einstuf?: number;
	einstufArt?: string;
	empfArt?: string;
	empfEinh?: string;
	feierkey?: string;
	flsVerrkey?: string;
	kokey?: string;
	limitkey?: string;
	persNrs: number[];
	reiseSchl?: string;
	stkey?: string;
	tolera?: number;
	ueberstdBer?: string;
	vondat: number;
}

export interface PersstCopyRequestTO {
	bisdat: number;
	cpAuslandKz?: JaNeinTO;
	cpAzebukz?: JaNeinTO;
	cpBewEinh?: JaNeinTO;
	cpClearPersstTag?: JaNeinTO;
	cpEinstuf?: JaNeinTO;
	cpEinstufArt?: JaNeinTO;
	cpEmpfArt?: JaNeinTO;
	cpEmpfEinh?: JaNeinTO;
	cpFeierkey?: JaNeinTO;
	cpFlsVerrkey?: JaNeinTO;
	cpKokey?: JaNeinTO;
	cpLimitkey?: JaNeinTO;
	cpMaBooking?: JaNeinTO;
	cpPersstTag?: JaNeinTO;
	cpReiseSchl?: JaNeinTO;
	cpStkey?: JaNeinTO;
	cpTolera?: JaNeinTO;
	cpUeberstdBer?: JaNeinTO;
	persNrs: number[];
	sourcePersNr: number;
	vondat: number;
}

export interface PersstDialogCFDefTO {
	copy: CustomFieldTO[];
	persst: CustomFieldTO[];
	persstTag: CustomFieldTO[];
}

export interface PersstResultTO {
	maBookings: ModelChangeBookingTO[];
	persNr: number;
	persst: PersstTO[];
	persstTag: PersstTagTO[];
}

export interface PersstTO {
	auslandKz: string;
	azebukz: string;
	bewEinh: string;
	bisdat: number;
	einstuf: number;
	einstufArt: string;
	empfArt: string;
	empfEinh: string;
	feierkey: string;
	flsVerrkey: string;
	kokey: string;
	limitkey: string;
	persNr: number;
	reiseSchl: string;
	stkey: string;
	tolera: number;
	ueberstdBer: string;
	vondat: number;
}

export interface PersstTagChangeRequestTO {
	bisdat: number;
	persNrs: number[];
	stTagkey?: string;
	stkey?: string;
	vondat: number;
}

export interface PersstTagTO {
	datum: number;
	persNr: number;
	stTagkey: string;
	stkey: string;
}

export interface PersurlTO {
	altRepresentative: number;
	cf: AttachmentTO[];
	end: number;
	hourCategory: string;
	id: number;
	openMarking: string;
	persNr: number;
	representative: number;
	sisName: string;
	start: number;
	stornos: StornoTO[];
	text: string;
}

export interface PlanEntryTO {
	bewEinh: string;
	bookingDate: number;
	bookingTime: number;
	bookingTimespan: number;
	bookingType: string;
	empfEinh: string;
	hourCategory: string;
	id: string;
	persNr: number;
	sisName: string;
	stKey: string;
	stTagKey: string;
	text: string;
}

export interface PlanMastTO {
	aktiv: boolean;
	del: boolean;
	endDat: number;
	id: number;
	inUse: boolean;
	periods: number;
	planText: string;
	rd: boolean;
	startDat: number;
	tage: PlanTagTO[];
	upd: boolean;
}

export interface PlanPersRequestTO {
	endDat: number | null;
	persNr: number | null;
	planMast: number;
	startDat: number;
	weeksHours: number[];
}

export interface PlanPersTO {
	endDat?: number | null;
	id: number;
	persNr: number;
	planMast: number;
	planText: string;
	startDat: number;
}

export interface PlanTagTO {
	id: number;
	mpause: number;
	planMast: number;
	tagorder: number;
	tagzsp: number;
	valid: boolean;
}

export interface PlanTemplTO {
	bewEinh: string;
	bookingTime: number;
	bookingTimespan: number;
	bookingType: string;
	empfEinh: string;
	hourCategory: string;
	id: number;
	planTag: number;
	sisName: string;
	stKey: string;
	stTagKey: string;
	text: string;
}

export interface PresenceStatusTO {
	absenceInfo: AbsenceInfoTO;
	absenceInfoText: string;
	arbverh: string;
	arbverhText: string;
	assignment: string;
	assignmentText: string;
	buchnr: number;
	cardNr: number;
	clearedBy: number;
	department: string;
	departmentText: string;
	extPersnr: string;
	farbeText: string;
	firstName: string;
	icon: string;
	lastName: string;
	operation: string;
	operationText: string;
	persNr: number;
	persurlnr: number;
	presence: string;
	schuhgr: string;
	status: string;
	statusText: string;
	territory: string;
	territoryText: string;
}

export interface RenameChatRequestTO {
	chatId: number;
	name?: string;
}

export interface RepParamTO {
	cfdef: number;
	colSpan: number;
	hpos: number;
	id: number;
	rowSpan: number;
	s_key: string;
	vpos: number;
	zpos: number;
}

export interface ReportRequestTO {
	bcc: string[];
	cc: string[];
	params: { [index: string]: string };
	subject: string;
	title: string;
	to: string[];
}

export interface ReportResponseTO {
	bcc: CustomFieldTO;
	cc: CustomFieldTO;
	mail: string;
	tabTitle: string;
	title: string;
}

export interface RestrictionTO {
	column: string;
	type?: RestrictionType;
	value: any;
}

export interface RulesetTO {
	abltext?: string;
	allDay: boolean;
	buchzeitBisEingebbar: boolean;
	buchzeitBisInit: number;
	buchzeitBisInitAus: string;
	buchzeitBisTakt: number;
	buchzeitBisTaktA: string;
	buchzeitBisTaktAus: string;
	buchzeitVonEingebbar: boolean;
	buchzeitVonInit: number;
	buchzeitVonInitAus: string;
	buchzeitVonTakt: number;
	buchzeitVonTaktAus: string;
	buchzeitVonZwingend: boolean;
	buchzspEingebbar: boolean;
	buchzspInit: number;
	buchzspZwingend: boolean;
	butextDq: string;
	butextKostmm: string;
	butextLaenge: number;
	butextText: string;
	butextTyp: string;
	butextZwingend: boolean;
	checkMaxDuration: boolean;
	checkbox: boolean;
	customFieldDefinitions: CustomFieldTO[];
	einstufEingebbar: boolean;
	einstufNK: number;
	einstufText: string;
	einstufZwingend: boolean;
	gentext?: string;
	maxRowsView?: number;
	minRowsView?: number;
	zspArt: ZspArt;
}

export interface Serializable {
}

export interface StPreviewTO {
	datum: number;
	stTagkey: string;
}

export interface StTO {
	anzTage: number;
	feierSollKz: string;
	genKz: string;
	stkey: string;
	sttext: string;
	verrkey: string;
}

export interface StTagTO {
	abAnwP1: number;
	abAnwP2: number;
	abAnwP3: number;
	begP1: number;
	begP2: number;
	begP3: number;
	colorBg: string;
	colorTxt: string;
	endeP1: number;
	endeP2: number;
	endeP3: number;
	glzBeg: number;
	glzEnde: number;
	id: string;
	kernBeg: number;
	kernEnde: number;
	normalAz: number;
	normalBeg: number;
	normalEnde: number;
	rundartEB: string;
	rundartLB: string;
	rundartWE: string;
	rundkonstEB: number;
	rundkonstLB: number;
	rundkonstWE: number;
	sollAz: number;
	sollP1: number;
	sollP2: number;
	sollP3: number;
	stTagText: string;
	tagBeg: number;
	tolNBeg: number;
	tolNEnde: number;
	tolVBeg: number;
	tolVEnde: number;
	welcheBu: string;
}

export interface StTagZuTO {
	compositeId: string;
	date: number;
	persNr: number;
	sisName: string;
	soll: number;
	stTagKey: string;
}

export interface StatusForecastTO extends DTSpannable {
	compositeId: string;
	persNr: number;
	sisName: string;
	status: string;
}

export interface StatusTO {
	abwesendKz: boolean;
	arbeitKz: boolean;
	color: ColorPairTO;
	icon: string;
	loeschKz: boolean;
	stTagbekey: string;
	status: string;
	statusText: string;
	zgKey: string;
}

export interface StornoTO {
	answer: boolean;
	id: number;
	sisName: SisName;
	text: string;
	user: string;
	userText: string;
}

export interface TableColumnPairTO {
	childCol: string;
	parentCol: string;
}

export interface TableRelationTO {
	boundBy: TableColumnPairTO[];
	childTable: string;
	icon?: string;
	id: number;
	label?: string;
	parentTable: string;
	relType: string;
}

export interface TaskAttrTO {
	id: number;
	key: string;
	position: number;
	task: number;
	type: string;
	value: string;
}

export interface TaskTO {
	color: ColorPairTO;
	id: number;
	name: string;
	perm: PermissionTO;
	taskAttrs: TaskAttrTO[];
}

export interface TaskZuMultiTO {
	_doSplit?: boolean;
	_splitAllowed?: boolean;
	bisdat: number;
	biszeit: number;
	color?: ColorPairTO;
	id: number;
	persNrs: number[];
	prio: number;
	sisName: string;
	task: number;
	text: string;
	vondat: number;
	vonzeit: number;
}

export interface TaskZuOverlapsTO {
	persurl: PersurlTO[];
	taskZu: TaskZuTO[];
}

export interface TaskZuTO {
	_doSplit?: boolean;
	_splitAllowed?: boolean;
	bisdat: number;
	biszeit: number;
	color?: ColorPairTO;
	id: number;
	persNr: number;
	prio: number;
	sisName: string;
	task: number;
	text: string;
	vondat: number;
	vonzeit: number;
}

export interface TranslationTO {
	attribute: string;
	language: string;
	value: string;
}

export interface TypeGroupTO extends Serializable {
	bgColor: string;
	fgColor: string;
	icon: string;
	id: number;
	nr: number;
	text: string;
	textLong: string;
}

export interface TypeStateMemberTO {
	buart: string;
	id: number;
	nr: number;
	stuart: string;
	typeState: string;
}

export interface Typemap2umTO {
	aufBuart: string;
	aufStuart: string;
	buart: string;
	id: number;
	stuart: string;
	zgKey: string;
}

export interface V2TO {
	bewEinh: string;
	bookingNr: number;
	buart: string;
	color: ColorPairTO;
	datum: number;
	datumVon: number;
	empfEinh: string;
	persNr: number;
	rowId: string;
	sisName: string;
	stuart: string;
	stuarttext: string;
	zeitVon: number;
	zsp: number;
}

export interface VBustuBaseTO {
	altRepresentative: number;
	bewEinh: string;
	bookingTime: number;
	bookingTimespan: number;
	bookingType: string;
	einstuf: number;
	empfEinh: string;
	endDate: number;
	evaluationLink: string;
	hourCategory: string;
	id: number;
	majorGenType: string;
	majorType: string;
	mixedId: string;
	openMarking: string;
	openStorno: boolean;
	persNr: number;
	representative: number;
	sisName: SisName;
	startDate: number;
	text: string;
}

export interface ViewStoreEntryTO {
	id: number;
	key: string;
	parent: number;
	value: any;
	view: string;
}

export interface ViewStoreTO {
	id: number;
	view: string;
}

export interface VlFehlTO {
	datum: number;
	fehlerArt: FehlerArt;
	fehlerNr: number;
	fehlerText: string;
	nr: number;
	persNr: number;
	progNr: number;
}

export interface VorgztUserTO {
	className: string;
	displayName: string;
	id: string;
	longUsername: string;
	text: string;
}

export interface WTMonitorTO {
	createdTS: number;
	day: number;
	last17weeks: number;
	lastStatus: string;
	month: number;
	requestedDate: number;
	validResultUntil: number;
	week: number;
}

export interface WorkTimeModelTO {
	compositeId: string;
	coreEnd: number;
	coreStart: number;
	date: number;
	endStepSize: number;
	flexEnd: number;
	flexStart: number;
	maxDuration: number;
	normalEnd: number;
	normalStart: number;
	persNr: number;
	soll: number;
	startStepSize: number;
}

export interface ZgTO {
	buart: string;
	fehlerArt: number;
	fehlerNr: number;
	statusAlt: string;
	statusNeu: string;
	v1Erste: string;
	v1Zweite: string;
	zgKey: string;
}

export enum AttachmentFetchMode {
	LAZY = "lazy",
	PREVIEW = "preview",
	EAGER = "eager",
}

export enum ColumnFilterMethod {
	Default = "default",
	IgnoreCase = "IgnoreCase",
	Exact = "Exact",
	ExactIgnoreCase = "ExactIgnoreCase",
	Date = "Date",
	Time = "Time",
	Duration = "Duration",
}

export enum EFileEntity {
	PERS = "pers",
	TASK = "task",
	KOST = "kost",
	AUFT = "auft",
}

export enum FehlerArt {
	UNKNOW = "UNKNOW",
	ERROR = "ERROR",
	WARNING = "WARNING",
}

export enum FreigabeType {
	Person = "Person",
	Kost = "Kost",
}

export enum JaNeinTO {
	J = "J",
	N = "N",
}

export enum ModuleType {
	WEBCLIENT = "0001",
	WEBCLIENT_CGI = "0002",
	EVOAPPS = "0003",
	EVOAPPS_HIDDEN = "9003",
	EVOAPPS_COCKPIT = "0004",
}

export enum NotiBusinessKeyTO {
	ChatMessageNew = "chat_msg_new",
}

export enum NotiStatus {
	SENT = "S",
	QUEUED = "Q",
	FAVORITE = "F",
}

export enum OrderDirection {
	ASC = "ASC",
	DESC = "DESC",
}

export enum PersonMetaImplEnumTO {
	EVENT = "EVENT",
	PERSST = "PERSST",
	TASK = "TASK",
}

export enum PropType {
	IProperty = "i",
	UserProperty = "u",
	VirtualProperty = "v",
	Paramdiv = "p",
}

export enum RestrictionType {
	EQ = "EQ",
	EQ_IC = "EQ_IC",
	NEQ = "NEQ",
	NEQ_IC = "NEQ_IC",
	LIKE = "LIKE",
	LIKE_IC = "LIKE_IC",
	NLIKE = "NLIKE",
	NLIKE_IC = "NLIKE_IC",
	DATE = "DATE",
	TIME = "TIME",
	DURATION = "DURATION",
}

export enum SisName {
	Booking = "booking",
	Persurl = "persurl",
	PlanTempl = "PlanTempl",
	PlanEvent = "PlanEvent",
}

export enum SisType {
	GPS = "G",
	Blob = "B",
	String = "C",
	Key = "K",
	Int = "I",
	Number = "N",
	Decimal = "E",
	Float = "F",
	Date = "D",
	Time = "T",
	Duration = "H",
	Duration2 = "Z",
	DurationA = "A",
	VChar = "V",
}

export enum ZspArt {
	Betrag = "B",
	Spanne = "S",
}
